<template>
  <div class="wt2-dashboard-filters wt2-discover-filters">
    <div class="-body">
      <section class="-type">
        <div class="-label">{{ 'dashboardFilter.type' | culture }}</div>
        <div>
          <wt-radio-box
            class="-control"
            v-for="radio in type"
            :key="radio.value"
            group="storiesInProgressType"
            :selected="radio.selected"
            :value="radio.value"
            :labelRight="radio.label"
            @select="onChangeType"
          />
        </div>
      </section>
      <section class="-category">
        <div class="-label">{{ 'dashboardFilter.category' | culture }}</div>
        <div>
          <wt-dropdown
            type="underline normal"
            :items="categoryList"
            :num-items="Math.min(7, categoryList.length)"
            :current-item-id="selectedCategoryId"
            :on-click-item="onChangeCategory"
          />
        </div>
      </section>
    </div>

    <div class="-footer">
      <wt-button
        type="primary"
        :text="'generic.APPLY' | culture"
        @click="onApply"
      />
      <wt-button
        class="-min-width-unset"
        type="transparent"
        :text="'generic.CANCEL' | culture"
        @click="onCancel"
      />
    </div>
  </div>
</template>

<script>
import app from 'app';
import { mapState } from 'vuex';

export default {
  name: 'discovery-filters',
  props: {
    /**
     * aux method to close parent dropdown-view
     */
    close: {
      type: Function,
      required: false,
      default: _.noop,
    },

    /**
     * Dashboard discovery filters
     */
    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      type: [
        {
          selected: true,
          value: 'ALL',
          payload: null,
          label: app.culture.dashboardFilter.filterAll,
        },
        {
          selected: false,
          value: 'VO',
          payload: true,
          label: app.culture.dashboardFilter.filterVO,
        },
        {
          selected: false,
          value: 'NOVO',
          payload: false,
          label: app.culture.dashboardFilter.filterNoVo,
        },
      ],
      selectedCategoryId: null,
    };
  },

  computed: {
    categoryList() {
      const storyCategories = this.readyMadeCategories || [];
      return [
        {
          id: null,
          label: app.culture.dashboardFilter.allCategories,
        },
        ...storyCategories,
      ];
    },
    ...mapState({
      readyMadeCategories: (state) => state.dashboard.readyMadeCategories,
    }),
  },

  created() {
    _.each(this.type, (radio) => {
      radio.selected = radio.payload === this.options.voiceOver;
    });
    const category = _.find(this.readyMadeCategories, (c) => {
      return c.label === this.options.category;
    });
    this.selectedCategoryId = category?.id || null;
  },

  methods: {
    onCancel() {
      this.close();
    },

    onApply() {
      const selectedType = _.find(this.type, (radio) => radio.selected);
      const category = _.find(this.readyMadeCategories, (c) => {
        return c.id === this.selectedCategoryId;
      });
      const categoryLabel = (category && category.label) || '';

      this.$emit('apply', {
        voiceOver: selectedType.payload,
        category: categoryLabel,
      });
      this.close();
    },

    onChangeType(value) {
      // reflect selected value in `this.type` array
      _.each(this.type, (radio) => {
        radio.selected = radio.value === value;
      });
    },

    onChangeCategory(itemId) {
      this.selectedCategoryId = itemId;
    },
  },
};
</script>
